import { InstagramIcon, LinkedinIcon, TwitterIcon, YoutubeIcon } from "lucide-react";
import Link from "next/link";
import Image from "next/image";

const MiniFooter = () => {
	return (
		<footer className="flex items-center bg-brand-dark p-6 text-white">
			<div className="mx-auto flex w-full max-w-6xl flex-wrap items-center justify-between gap-8 md:flex-nowrap md:justify-between md:gap-0">
				<nav className="flex flex-col items-start justify-start gap-y-1.5">
					<p className="text-sm text-white">PropTechBuzz.</p>
					<p className="text-sm text-white">
						&copy; {new Date().getFullYear()}. All Rights Reserved
					</p>
				</nav>

				<div className="flex flex-col items-start justify-between gap-8 sm:flex-row md:flex-nowrap md:justify-between">
					<nav className="flex flex-col items-start justify-start gap-y-2">
						<div>
							<Link href="/contact-us" className="text-xs font-semibold uppercase">
								Available on
							</Link>
						</div>
						<div className="flex items-center justify-between gap-4">
							<Link
								href="https://apps.apple.com/us/app/proptechbuzz/id6504497268"
								target="_blank"
								aria-label="App Store"
								rel="nofollow"
								className="flex items-center justify-start gap-x-2 rounded-md bg-black px-2 py-1"
							>
								<Image
									src="/images/home/footer/apple-logo.png"
									alt="Apple Logo"
									width={40}
									height={40}
									className="h-6 w-6"
								/>

								<div className="flex flex-col items-start justify-start">
									<p className="text-xxs text-white">Download on the</p>
									<p className="text-sm font-semibold text-white">App Store</p>
								</div>
							</Link>
							<Link
								href="https://play.google.com/store/apps/details?id=com.proptechbuzz.app"
								target="_blank"
								aria-label="Google Play"
								rel="nofollow"
								className="flex items-center justify-start gap-x-2 rounded-md bg-black px-2 py-1"
							>
								<Image
									src="/images/home/footer/google-play-logo.png"
									alt="Google Play Logo"
									width={40}
									height={40}
									className="h-6 w-6"
								/>

								<div className="flex flex-col items-start justify-start">
									<p className="text-xxs uppercase text-white">Get it on</p>
									<p className="text-sm font-semibold text-white">Google Play</p>
								</div>
							</Link>
						</div>
					</nav>

					<nav className="flex flex-col items-start justify-start gap-y-5">
						<ul>
							<Link href="/contact-us" className="text-xs font-semibold uppercase">
								Contact Us
							</Link>
						</ul>
						<ul className="flex items-center justify-start gap-x-4">
							<li>
								<Link
									href="https://twitter.com/proptechbuzz"
									target="_blank"
									aria-label="PropTechBuzz on Twitter"
									rel="nofollow"
								>
									<TwitterIcon className="h-6 w-6" />
								</Link>
							</li>
							<li>
								<Link
									href="https://www.linkedin.com/company/proptechbuzz"
									target="_blank"
									aria-label="PropTechBuzz on LinkedIn"
									rel="nofollow"
								>
									<LinkedinIcon className="h-6 w-6" />
								</Link>
							</li>
							<li>
								<Link
									href="https://www.youtube.com/@proptechbuzz"
									target="_blank"
									aria-label="PropTechBuzz on YouTube"
									rel="nofollow"
								>
									<YoutubeIcon className="h-6 w-6" />
								</Link>
							</li>
							<li>
								<Link
									href="https://www.instagram.com/proptechbuzz/"
									target="_blank"
									aria-label="PropTechBuzz on Instagram"
									rel="nofollow"
								>
									<InstagramIcon className="h-6 w-6" />
								</Link>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</footer>
	);
};

export default MiniFooter;
